<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <div class="select">
          <div class="item">
            <el-select v-model="tenantId" placeholder="租户选择" clearable style="width: 220px">
              <el-option v-for="item in tenantList" :key="item.id" :label="item.tenantName" :value="item.id" />
            </el-select>
          </div>
          <div class="item">
            <el-button size="small" type="primary" @click="handleSearch">查询</el-button>
          </div>
        </div>
      </div>

      <el-row :gutter="16" class="split-layout">
        <el-col :span="9">
          <el-card shadow="never" class="left-tree-card">
            <div slot="header" class="tree-header">角色树</div>
            <el-input
              v-model="roleKeyword"
              size="small"
              clearable
              placeholder="搜索角色名称/编码"
              class="tree-search"
            />
            <el-tree
              ref="roleTree"
              :data="roleTree"
              node-key="id"
              highlight-current
              :default-expand-all="false"
              :props="{ children: 'children', label: 'name' }"
              :filter-node-method="filterRoleNode"
              @node-click="handleRoleClick"
            >
              <span slot-scope="{ data }" class="tree-node">
                <span class="tree-node-label">
                  <span>{{ data.name }}</span>
                  <el-tag v-if="data.parentId === 0" size="mini" type="danger" class="type-tag">顶级</el-tag>
                </span>
                <span class="tree-node-actions">
                  <el-button type="text" size="mini" @click.stop="showAddChild(data)">新增下级</el-button>
                  <el-button type="text" size="mini" @click.stop="showEdit(data)">编辑</el-button>
                </span>
              </span>
            </el-tree>
          </el-card>
        </el-col>

        <el-col :span="15">
          <el-card shadow="never" class="right-card">
            <div slot="header" class="detail-header">
              <span>{{ isCreate ? "新增下级角色" : (isEditMode ? "编辑角色" : "角色详情") }}</span>
              <span class="detail-header-right">
                <el-tag size="mini" :type="isCreate ? 'success' : (isEditMode ? 'warning' : 'info')">
                  {{ isCreate ? "新增模式" : (isEditMode ? "编辑模式" : "查看模式") }}
                </el-tag>
              </span>
            </div>

            <el-form :model="formData" label-width="110px" size="medium">
              <el-form-item label="角色名称" required>
                <el-input v-model="formData.name" :disabled="!isEditMode" />
              </el-form-item>
              <el-form-item label="角色编码" required>
                <el-input v-model="formData.code" :disabled="isSuperAdmin || !isEditMode" />
              </el-form-item>
              <el-form-item label="排序">
                <el-input-number v-model="formData.sort" :min="0" style="width: 100%" :disabled="!isEditMode" />
              </el-form-item>
              <el-form-item label="停用">
                <el-switch v-model="formData.status" :disabled="!isEditMode" />
              </el-form-item>
              <el-form-item label="备注">
                <el-input v-model="formData.remark" type="textarea" :rows="2" :disabled="!isEditMode" />
              </el-form-item>
            </el-form>

            <div class="menu-title-row">
              <span class="menu-title">菜单权限（仅展示父角色已拥有权限）</span>
              <span>
                <el-button size="mini" @click="toggleAllExpand(true)">一键展开</el-button>
                <el-button size="mini" @click="toggleAllExpand(false)">一键收起</el-button>
              </span>
            </div>
            <el-tree
              ref="menuTree"
              :data="menuTree"
              node-key="id"
              show-checkbox
              :check-strictly="true"
              check-on-click-node
              :default-expand-all="false"
              :props="{ children: 'children', label: 'name', disabled: 'disabled' }"
              @check-change="handleMenuCheckChange"
            >
              <span slot-scope="{ data }">
                <span>{{ data.name }}</span>
                <el-tag size="mini" type="info" class="type-tag">{{ typeName(data.type) }}</el-tag>
              </span>
            </el-tree>

            <div class="detail-actions">
              <el-button
                v-if="!isCreate && currentRole && !isEditMode"
                type="primary"
                @click="enableEdit"
              >
                进入编辑
              </el-button>
              <el-button
                v-if="!isCreate && currentRole && isEditMode"
                @click="cancelEdit"
              >
                取消编辑
              </el-button>
              <el-button v-if="isEditMode" type="primary" @click="saveRole">
                {{ isCreate ? "创建下级角色" : "保存角色" }}
              </el-button>
              <el-button
                v-if="!isCreate && currentRole && currentRole.parentId !== 0"
                type="danger"
                @click="removeRole(currentRole)"
              >
                删除角色
              </el-button>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import api from "./api";
import { tenantInfo } from "@/common/publicApi";

const defaultForm = () => ({
  id: undefined,
  tenantId: "",
  parentId: 0,
  name: "",
  code: "",
  sort: 0,
  status: false,
  dataScope: 2,
  remark: "",
});

export default {
  data() {
    return {
      tenantId: "",
      tenantList: [],
      roleTree: [],
      roleKeyword: "",
      currentRole: null,
      isCreate: false,
      isEditMode: true,
      isSuperAdmin: false,
      menuCheckSyncing: false,
      menuTree: [],
      formData: defaultForm(),
    };
  },
  watch: {
    roleKeyword(val) {
      this.$refs.roleTree && this.$refs.roleTree.filter(val);
    },
  },
  mounted() {
    tenantInfo().then((res) => {
      if (res.code === 0) {
        this.tenantList = res.data || [];
        if (!this.tenantId && this.tenantList.length) {
          this.tenantId = this.tenantList[0].id;
        }
        this.handleSearch();
      }
    });
  },
  methods: {
    typeName(type) {
      if (type === 1) return "目录";
      if (type === 2) return "菜单";
      return "按钮";
    },
    filterRoleNode(value, data) {
      if (!value) {
        return true;
      }
      return (data.name || "").includes(value) || (data.code || "").includes(value);
    },
    handleSearch() {
      if (!this.tenantId && this.tenantId !== 0) {
        return this.$message.error("请选择租户");
      }
      api.tree({ tenantId: this.tenantId }).then((res) => {
        if (res.code === 0) {
          this.roleTree = res.data || [];
          const root = this.findFirstRoot(this.roleTree);
          if (root) {
            this.$nextTick(() => {
              this.$refs.roleTree && this.$refs.roleTree.setCurrentKey(root.id);
            });
            this.handleRoleClick(root);
          } else {
            this.resetRightPanel();
          }
        }
      });
    },
    findFirstRoot(tree) {
      if (!tree || !tree.length) {
        return null;
      }
      return tree[0];
    },
    handleRoleClick(role, options = {}) {
      const { editMode = false } = options;
      this.currentRole = role;
      this.isCreate = false;
      this.isEditMode = !!editMode;
      this.isSuperAdmin = role.parentId === 0;
      this.formData = {
        id: role.id,
        tenantId: role.tenantId,
        parentId: role.parentId,
        name: role.name || "",
        code: role.code || "",
        sort: role.sort || 0,
        status: !!role.status,
        dataScope: role.dataScope || 2,
        remark: role.remark || "",
      };
      this.loadMenuScope({ roleId: role.id });
    },
    showAddChild(role) {
      this.currentRole = role;
      this.isCreate = true;
      this.isEditMode = true;
      this.isSuperAdmin = false;
      this.formData = defaultForm();
      this.formData.tenantId = role.tenantId;
      this.formData.parentId = role.id;
      this.formData.sort = 1;
      this.loadMenuScope({ parentRoleId: role.id });
    },
    showEdit(role) {
      this.handleRoleClick(role, { editMode: true });
    },
    loadMenuScope(params) {
      const query = {
        tenantId: this.tenantId,
        ...params,
      };
      api.menuTree(query).then((res) => {
        if (res.code === 0) {
          const data = res.data || {};
          this.menuTree = this.decorateMenuTree(data.tree || []);
          const checked = this.normalizeCheckedMenuIds(data.checkedMenuIds || []);
          this.$nextTick(() => {
            this.$nextTick(() => {
              if (this.$refs.menuTree) {
                this.menuCheckSyncing = true;
                this.$refs.menuTree.setCheckedKeys([]);
                this.$refs.menuTree.setCheckedKeys(checked);
                this.menuCheckSyncing = false;
              }
            });
          });
        }
      });
    },
    normalizeCheckedMenuIds(ids) {
      const out = [];
      (ids || []).forEach((id) => {
        if (id === null || id === undefined || id === "") {
          return;
        }
        const n = typeof id === "number" ? id : Number(id);
        if (!Number.isNaN(n)) {
          out.push(n);
        }
      });
      return Array.from(new Set(out));
    },
    decorateMenuTree(tree) {
      return (tree || []).map((node) => ({
        ...node,
        disabled: !this.isEditMode,
        children: this.decorateMenuTree(node.children || []),
      }));
    },
    enableEdit() {
      if (!this.currentRole || !this.currentRole.id) {
        return;
      }
      this.isEditMode = true;
      this.loadMenuScope({ roleId: this.currentRole.id });
    },
    cancelEdit() {
      if (!this.currentRole) {
        return;
      }
      this.handleRoleClick(this.currentRole);
    },
    toggleAllExpand(expanded) {
      if (!this.$refs.menuTree || !this.$refs.menuTree.store) {
        return;
      }
      const nodesMap = this.$refs.menuTree.store.nodesMap || {};
      Object.keys(nodesMap).forEach((key) => {
        nodesMap[key].expanded = expanded;
      });
    },
    getCheckedMenuIds() {
      if (!this.$refs.menuTree) {
        return [];
      }
      const checked = this.$refs.menuTree.getCheckedKeys(false) || [];
      const half = this.$refs.menuTree.getHalfCheckedKeys() || [];
      return Array.from(new Set([...(checked || []), ...(half || [])]));
    },
    handleMenuCheckChange(data, checked) {
      if (!this.isEditMode || this.menuCheckSyncing || !this.$refs.menuTree || !data || !data.id) {
        return;
      }
      const node = this.$refs.menuTree.getNode(data.id);
      if (!node) {
        return;
      }
      this.menuCheckSyncing = true;
      try {
        if (checked) {
          this.markParentChecked(node.parent);
          return;
        }
        this.clearChildChecks(node);
      } finally {
        this.menuCheckSyncing = false;
      }
    },
    markParentChecked(parentNode) {
      let parent = parentNode;
      while (parent && parent.data && parent.data.id) {
        this.$refs.menuTree.setChecked(parent.data.id, true, false);
        parent = parent.parent;
      }
    },
    clearChildChecks(node) {
      const children = node.childNodes || [];
      children.forEach((child) => {
        if (child && child.data && child.data.id) {
          this.$refs.menuTree.setChecked(child.data.id, false, false);
          this.clearChildChecks(child);
        }
      });
    },
    saveRole() {
      if (!this.tenantId && this.tenantId !== 0) {
        return this.$message.error("请选择租户");
      }
      if (!this.formData.name) {
        return this.$message.error("请输入角色名称");
      }
      if (!this.formData.code) {
        return this.$message.error("请输入角色编码");
      }
      const payload = {
        ...this.formData,
        tenantId: this.tenantId,
        menuIds: this.getCheckedMenuIds(),
      };
      const req = this.isCreate ? api.add : api.update;
      req(payload).then((res) => {
        if (res.code === 0) {
          this.$message.success("操作成功");
          this.handleSearch();
        }
      });
    },
    removeRole(role) {
      this.$confirm("删除角色后不可恢复，确认继续吗？", "提示", {
        type: "warning",
      }).then(() => {
        api.remove({ id: role.id }).then((res) => {
          if (res.code === 0) {
            this.$message.success("删除成功");
            this.handleSearch();
          }
        });
      });
    },
    resetRightPanel() {
      this.currentRole = null;
      this.isCreate = false;
      this.isEditMode = true;
      this.isSuperAdmin = false;
      this.formData = defaultForm();
      this.formData.tenantId = this.tenantId || "";
      this.menuTree = [];
      this.$nextTick(() => {
        this.$refs.menuTree && this.$refs.menuTree.setCheckedKeys([]);
      });
    },
  },
};
</script>

<style lang="less" src="../../styles/button.less" scoped></style>
<style lang="less" scoped>
.split-layout {
  margin-top: 8px;
}

.left-tree-card,
.right-card {
  height: calc(100vh - 240px);
  overflow: auto;
}

.tree-header,
.detail-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 600;
}

.tree-search {
  margin-bottom: 10px;
}

.tree-node {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.tree-node-label {
  display: inline-flex;
  align-items: center;
}

.type-tag {
  margin-left: 8px;
}

.tree-node-actions {
  margin-left: 8px;
}

.menu-title-row {
  margin: 10px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.menu-title {
  font-weight: 600;
}

.detail-actions {
  margin-top: 12px;
  display: flex;
  justify-content: flex-end;
}
</style>
